import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './initialState';

const stripeSubscribeSessionSlice = createSlice({
  name: 'stripeSubscribeSession',
  initialState: initialState.stripeSubscribeSession,
  reducers: {
    postStripeSubscriptionCheckoutSessionUrlRequest(
      state,
      _action: PayloadAction<{ advisorId: string; priceId?: string }>,
    ) {
      state.isLoading = true;
      state.error = false;
    },
    postStripeSubscriptionCheckoutSessionUrlResponse(
      state,
      action: PayloadAction<{ url: string }>,
    ) {
      state.isLoading = false;
      state.success = true;
      state.url = action.payload.url;
    },
    postStripeSubscriptionCheckoutSessionUrlFailure(
      state,
      action: PayloadAction<any>,
    ) {
      state.isLoading = false;
      state.error = true;
    },
  },
});

export const {
  postStripeSubscriptionCheckoutSessionUrlRequest,
  postStripeSubscriptionCheckoutSessionUrlResponse,
  postStripeSubscriptionCheckoutSessionUrlFailure,
} = stripeSubscribeSessionSlice.actions;

export const stripeSubscribeSessionReducer =
  stripeSubscribeSessionSlice.reducer;
